// La file d'offres à trier (issue #170).
//
// Un mail de trois offres menait à la fiche de la première ; pour voir la
// deuxième, il fallait revenir à l'accueil et la retrouver. La file les
// enchaîne : la fiche dit « 2 sur 3 » et « Suivante », et après « Plus tard »
// ou « Pas pour moi », la suivante s'ouvre d'elle-même. Après la dernière,
// l'accueil dit que c'est fini.
//
// LA FILE VIT DANS L'ADRESSE (`#/offre/12?file=12,15,19`), pas dans l'état de
// l'écran : un lien de mail la porte, un rechargement la garde, et la fiche
// n'a rien à demander au serveur pour savoir où elle en est. Elle n'ouvre
// rien de plus que ce que le compte voit déjà : chaque fiche passe par la
// cloison comme si on l'avait ouverte à la main.

/** Au-delà, ce n'est plus un mail du matin qu'on trie, c'est une pile. */
export const MAX_FILE = 20

/** Les identifiants d'une file, dans l'ordre, sans doublon ni valeur suspecte. */
export function lireFile(brut: string | null | undefined): number[] {
  if (!brut) return []
  const ids = brut
    .split(/[,.]/)
    .map((x) => Number(x))
    .filter((n) => Number.isInteger(n) && n > 0)
  return [...new Set(ids)].slice(0, MAX_FILE)
}

/** L'adresse d'une fiche dans sa file (sans file d'une seule offre). */
export function lienFiche(id: number, file: number[]): string {
  return file.length > 1 && file.includes(id) ? `#/offre/${id}?file=${file.join(',')}` : `#/offre/${id}`
}

export interface Position {
  /** 1 pour la première. */
  rang: number
  total: number
  /** L'adresse de la suivante, ou null après la dernière. */
  suivante: string | null
}

/** Où cette fiche se trouve dans sa file ; null hors de toute file. */
export function position(id: number, file: number[]): Position | null {
  const i = file.indexOf(id)
  if (i < 0 || file.length < 2) return null
  const suivant = file[i + 1]
  return { rang: i + 1, total: file.length, suivante: suivant ? lienFiche(suivant, file) : null }
}

/** L'accueil, une fois la file finie : il le dit (`fin=1`). */
export const FIN_DE_FILE = '#/decisions?fin=1'
